const right = true;
const questions = [
    {
        image: '/images/questions/level_1/1-conquistador.jpg',
        statement: '¿Qué capitán dió el nombre de Los Realejos tras la conquista?',
        answers: [
            { text: "Alonso Fernández de Lugo", right },
            { text: "Juan Núñez de la Peña" },
            { text: "Antonio de Viana" }
        ]
    },
    {
        image: '/images/questions/level_1/2-barranco.jpg',
        statement: '¿En qué barranco se estableció el campamento castellano en Tenerife?',
        answers: [
            { text: "Barranco Godínez", right },
            { text: "Barranco Ruiz" },
            { text: "Barranco del Infierno" }
        ]
    },
    {
        image: '/images/questions/level_1/3-campamento.jpg',
        statement: '¿Qué población surgió a partir del campamento castellano en Tenerife?',
        answers: [
            { text: "Realejo Alto", right },
            { text: "Realejo Bajo" },
            { text: "La Laguna" }
        ]
    },
    {
        image: '/images/questions/level_1/4-cabildo.jpg',
        statement: '¿Qué nombre sugiere el Cabildo en 1952 para el municipio unificado?',
        answers: [
            { text: "Los Realejos de Taoro", right },
            { text: "El Real de Tenerife" },
            { text: "Los Realejos" }
        ]
    },
    {
        image: '/images/questions/level_1/5-escudos.jpg',
        statement: '¿Cúal es el escudo de Realejos Bajo?',
        answers: [
            { text: "B", right },
            { text: "A" },
            { text: "C" }
        ]
    },
    {
        image: '/images/questions/level_1/6-escudos.jpg',
        statement: '¿Cúal es el escudo de Realejos Alto?',
        answers: [
            { text: "A", right },
            { text: "B" },
            { text: "C" }
        ]
    },
    {
        image: '/images/questions/level_1/7-nombre.jpg',
        statement: '¿Qué significa el término del que deriva el nombre de Los Realejos?',
        answers: [
            { text: "Campamento militar", right },
            { text: "Lugar de descanso" },
            { text: "Albergue de viajeros" }
        ]
    },
    {
        image: '/images/questions/level_1/8-viera-clavijo.jpg',
        statement: '¿Quién documentó la historia de Realejo Alto y Realejo Bajo en el siglo XVIII?',
        answers: [
            { text: "José de Viera y Clavijo", right },
            { text: "Alonso Fernández de Lugo" },
            { text: "Antonio Rumeu de Armas" }
        ]
    },
    {
        image: '/images/questions/level_1/9-fusion-1955.jpg',
        statement: '¿En qué año se llevó a cabo la fusión definitiva de Realejo Alto y Realejo Bajo?',
        answers: [
            { text: "1955", right },
            { text: "1925" },
            { text: "1836" }
        ]
    },
    {
        image: '/images/questions/level_1/10-obstaculo.jpg',
        statement: '¿Cuál fue un obstáculo para la fusión en el siglo XIX?',
        answers: [
            { text: "Inestabilidad política", right },
            { text: "Desacuerdos económicos" },
            { text: "Falta de interés popular" }
        ]
    },
    {
        image: '/images/questions/level_1/11-paz.jpg',
        statement: '¿En qué año aconteció la “Paz de los Realejos” entre guanches y conquistadores?',
        answers: [
            { text: "1496", right },
            { text: "1402" },
            { text: "1483" }
        ]
    },
    {
        image: '/images/questions/level_1/12-bentor.jpg',
        statement: '¿Quién fue el último Mencey del menceyato de Taoro?',
        answers: [
            { text: "Bentor", right },
            { text: "Ichasagua" },
            { text: "Bencomo" }
        ]
    },
    {
        image: '/images/questions/level_1/13-batalla-taoro.jpg',
        statement: '¿Qué hito militar influyó en la creación de Realejo Alto?',
        answers: [
            { text: "La batalla de Taoro", right },
            { text: "La batalla de La Laguna" },
            { text: "La batalla de Acentejo" }
        ]
    },
];
export default questions;
